export type PropertyTypeLabel = string;

const PROPERTY_TYPE_NORMALIZATION_MAP: Record<string, PropertyTypeLabel> = {
  // Traditional Office
  "commercial workspace": "Traditional Office",
  "conventional workspace": "Traditional Office",
  "traditional office": "Traditional Office",

  // Coworking Space
  "coworking space": "Coworking Space",

  // Managed Space
  "managed office space": "Managed Space",
  "managed space": "Managed Space",

  // Serviced Office
  "serviced office (classic)": "Serviced Office",
  "serviced office (creative)": "Serviced Office",
  "serviced office": "Serviced Office",

  // Shared Space
  "shared workspace": "Shared Space",
  "shared space": "Shared Space",

  // Sublet Office
  "sublet office space (not shared)": "Sublet Office",
  "sublet office": "Sublet Office",

  // Retail
  "retail/pop up": "Retail",
  "retail": "Retail",
};

export function normalizePropertyTypeLabel(input?: unknown): PropertyTypeLabel | undefined {
  if (typeof input !== "string") return undefined;
  const key = input.trim().toLowerCase();
  if (!key) return undefined;
  return PROPERTY_TYPE_NORMALIZATION_MAP[key] ?? input;
}

